import React from "react";
import {useAppSelector} from "../../../../redux/hooks";
import stocksService from "../../../../api/services/stocksService";
import store from "../../../../redux/store";
import {setTemporaryNotifications} from "../../../../redux/notifications/actions";
import {defaultNotificationCreator} from "../../../../templates/Notifications";
import {setIsNeedUpdateData} from "../../../../redux/stocks/reducer";
import { ReactComponent as AddCircleFilledIcon } from '../../../../assets/icons/new/UI/AddCircleFilled.svg';
import PillActionButton from '../../../StocksLayout/PillActionButton';

// @ts-ignore
function SetStocksByXlsx({toCloseModalMenu}) {

    const { sellerId } = useAppSelector(({ sellers }) => ({
        sellerId: sellers.currentSeller.info.data?.id
    }))

    const [isProcessing, setIsProcessing] = React.useState<boolean>(false);
    const input = React.useRef(null);

    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files) {
            return
        }

        setIsProcessing(true)

        const selectedFile = e.target.files[0]
        e.target.value = ''

        if (!selectedFile) {
            return
        }

        stocksService
            .setStocksForSellerByXlsx(sellerId as number, selectedFile)
            .finally(() => {
                setIsProcessing(false)
                store.dispatch(setTemporaryNotifications(
                    //@ts-ignore
                    defaultNotificationCreator({
                        title: "Остатки установлены",
                        description: "",
                        iconType: "success"
                    })
                ))
                store.dispatch(setIsNeedUpdateData(true))
            })
    }


    const clickBtnHandler = ()  => {
        if (!input.current) {
            return
        }
        //@ts-ignore
        input.current?.click()
    }

    function clickHandler() {
        clickBtnHandler();
        if (toCloseModalMenu) {
            toCloseModalMenu();
        }
    }

    return (
        <div className="flex items-center">
            <input type="file" ref={input} onChange={handleFileSelect} className="hidden"/>
            <PillActionButton
                icon={AddCircleFilledIcon}
                label="Остатки"
                title="Загрузить остатки"
                onClick={clickHandler}
                loading={isProcessing}
            />
        </div>
    );
}

export default SetStocksByXlsx;
